"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.AIControlledMineNetwork = void 0;
var CardName_1 = require("../../CardName");
var CardType_1 = require("../CardType");
var Tags_1 = require("../Tags");
var MoonExpansion_1 = require("../../moon/MoonExpansion");
var CardRenderer_1 = require("../render/CardRenderer");
var CardRequirements_1 = require("../CardRequirements");
var Card_1 = require("../Card");
var AIControlledMineNetwork = (function (_super) {
    __extends(AIControlledMineNetwork, _super);
    function AIControlledMineNetwork() {
        return _super.call(this, {
            name: CardName_1.CardName.AI_CONTROLLED_MINE_NETWORK,
            cardType: CardType_1.CardType.AUTOMATED,
            tags: [Tags_1.Tags.SCIENCE],
            cost: 6,
            tr: { moonLogistics: 1 },
            requirements: CardRequirements_1.CardRequirements.builder(function (b) { return b.logisticRate(2); }),
            metadata: {
                description: 'Requires Logistic Rate to be 2 or higher. Raise the Logistic Rate 1 step',
                cardNumber: 'M32',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.moonLogisticsRate();
                }),
            },
        }) || this;
    }
    ;
    AIControlledMineNetwork.prototype.play = function (player) {
        MoonExpansion_1.MoonExpansion.raiseLogisticRate(player);
        return undefined;
    };
    return AIControlledMineNetwork;
}(Card_1.Card));
exports.AIControlledMineNetwork = AIControlledMineNetwork;
